import { render, staticRenderFns } from "./ScopeBiomarkerEvidenceTable.vue?vue&type=template&id=e8a710fe&scoped=true"
import script from "./ScopeBiomarkerEvidenceTable.vue?vue&type=script&lang=js"
export * from "./ScopeBiomarkerEvidenceTable.vue?vue&type=script&lang=js"
import style0 from "./ScopeBiomarkerEvidenceTable.vue?vue&type=style&index=0&id=e8a710fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a710fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a710fe')) {
      api.createRecord('e8a710fe', component.options)
    } else {
      api.reload('e8a710fe', component.options)
    }
    module.hot.accept("./ScopeBiomarkerEvidenceTable.vue?vue&type=template&id=e8a710fe&scoped=true", function () {
      api.rerender('e8a710fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeBiomarkerEvidenceTable.vue"
export default component.exports